import Skeleton, { SkeletonButton } from '@pixum/skeleton';
import type { ReactNode } from 'react';
import styles from './CartStepLayout.module.css';

interface CartStepLayoutSkeletonProps {
  children: ReactNode;
}

export function CartStepLayoutSkeleton({ children }: CartStepLayoutSkeletonProps) {
  return (
    <div className={styles.outer} aria-busy="true" aria-hidden="true">
      <div className={styles.inner}>
        <div className={styles.stepLayout}>
          <div className={styles.headingRow}>
            <Skeleton className={styles.skeletonTitle} />
            <SkeletonButton />
          </div>
          {children}
          <div className={styles.actions}>
            <SkeletonButton />
            <SkeletonButton />
          </div>
        </div>
      </div>
    </div>
  );
}